var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!--.col-md-2--><nav-ninja></nav-ninja>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/shell/content/navigation.jade
// module id = 155
// module chunks = 0